export default[
    {
        path: '/tabelaprecorublica/cadastro/:id/:status',
        name: 'cadastro de rublicas da tabela de preço', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/tabelaprecorublica/lista/:id',
        name: 'lista de rublicas da tabela de preço', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/tabelaprecorublica/editar/:tabelapreco/:id/:status',
        name: 'editar rublicas da tabela de preço', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]